import React from 'react';
import {
  Edit,
  Create,
  SimpleForm,
  NumberInput,
} from 'react-admin';

const WithdrawSettingsFields = () => (
  <>
    <NumberInput source="min_withdraw" label="Min withdraw" defaultValue={100} />
    <NumberInput source="withdraw_fee" label="Withdraw fee" defaultValue={0} />
    <NumberInput source="limit_multiplier" label="Limit multiplier" defaultValue={2} />
  </>
);

export const WithdrawSettingsEdit = (props) => (
  <Edit {...props}>
    <SimpleForm>
      <WithdrawSettingsFields />
    </SimpleForm>
  </Edit>
);

export const WithdrawSettingsCreate = (props) => (
  <Create {...props}>
    <SimpleForm>
      <WithdrawSettingsFields />
    </SimpleForm>
  </Create>
);